import React, { useEffect } from "react"
import {
  sendDelayedTrackEvents,
  useProductEvents,
  useSegment,
  useSegmentIdentify,
  useSegmentPage,
  useTrackAPIEvents,
  useVideoPlayerTracking,
} from "tracking"
import { useCarouselViewedEvent } from "tracking/hooks/useCarouselViewedEvent"
import { usePageElementEvents } from "tracking/hooks/usePageElementEvents"
import { useSwiperTracking } from "tracking/hooks/useSwiperTracking"
import { PageScrollTracker } from "./PageScrollTracker"
import { getBPFingerprint } from "../../lib/fingerprint"

type Props = {
  isOos?: boolean
  productIds?: string[]
  eventId?: string
}

export const Segment: React.FC<Props> = ({ isOos, productIds, eventId }) => {
  useSegmentPage({ isOos, productIds, eventId })
  useSegmentIdentify()
  const { track } = useSegment()
  const setupAPITracking = useTrackAPIEvents()
  const setupVideoTracking = useVideoPlayerTracking()
  const setupSwiperTracking = useSwiperTracking()
  const setupPageElementEvents = usePageElementEvents()
  const setupProductEvents = useProductEvents()
  const setupCarouselViewedEvent = useCarouselViewedEvent()
  useEffect(() => {
    setupAPITracking()
    setupVideoTracking()
    setupSwiperTracking()
    setupPageElementEvents()
    setupProductEvents()
    setupCarouselViewedEvent()
    const oneTrustGroupsUpdated = async () => {
      if (window.OneTrust.IsAlertBoxClosedAndValid()) {
        await getBPFingerprint()
        track({
          event: "OneTrust Cookie Consent Submitted",
          properties: {
            opt_in_strictly_necessary_cookie: true,
            opt_in_performance_cookie:
              window.OnetrustActiveGroups.includes("C0002"),
            opt_in_functional_cookie:
              window.OnetrustActiveGroups.includes("C0003"),
            opt_in_targeting_cookie:
              window.OnetrustActiveGroups.includes("C0004"),
          },
        })
      }
    }

    // Intercept when OneTrust is set on the window
    Object.defineProperty(window, "OneTrust", {
      configurable: true,
      set(value) {
        // Set the OneTrust value as usual
        Object.defineProperty(window, "OneTrust", {
          value,
          writable: true,
          configurable: true,
        })

        // Add the OnConsentChanged listener
        value.OnConsentChanged(oneTrustGroupsUpdated)
      },
    })

    return () => {
      window.removeEventListener("OnConsentChanged", oneTrustGroupsUpdated)
    } // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    sendDelayedTrackEvents()
  }, [])
  return (
    <>
      <PageScrollTracker />
    </>
  )
}
